import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from './../../../../billing-control/bc-account-client/service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { CommercialCompetenceService } from '../../../../commercial-competence/services/commercial-competence.service';
import { LimiteAdicionalProposalService } from '../../../../limite-adicional-proposal/service/limite-adicional-proposal/limite-adicional-proposal.service';

export interface ProposalViewModal {
	proposalID: string;
	proposalCod: string;
	accountClientID: string;
	currentClientDocument: string;
	tempGroup: any[];
	profileUser: string;
	segmentoID: string;
}

@Component({
	selector: 'proposal-view-modal',
	templateUrl: './proposal-view-modal.component.html',
	styleUrls: ['./proposal-view-modal.component.scss'],
	providers: [
		BcAccountClientService,
		CommercialCompetenceService,
		LimiteAdicionalProposalService
	]
})

export class ProposalViewModalComponent extends DialogComponent<ProposalViewModal, any> implements ProposalViewModal {
	proposalID: string;
	proposalCod: string;
	accountClientID: string;
	tempGroup: any[];
	profileUser: string;
	currentClientDocument: string;
	segmentoID: string;

	public proposal: any[] = [];
	public proposalType: string = "";
	loadProposal: boolean = false;

	constructor(
		dialogService: DialogService, 
		private bcAccountClientService: BcAccountClientService, 
		private flashMessagesService: FlashMessagesService, 
		private commercialCompetenceService: CommercialCompetenceService,
		private limiteAdicionalProposalService: LimiteAdicionalProposalService) {
		super(dialogService);
	}

	ngOnInit() {

		this.proposalType = this.proposalCod.substring(0, 2);
		if (this.proposalType == 'EC')
			this.proposalType = 'LC';

		console.log("Tipo de Proposta:", this.proposalType);

		switch (this.proposalType) {
			case 'LC':
				this.loadProposal = true;
				break;

			case 'JD':
				this.getJuridicProposal(this.proposalID);
				break;

			case 'PR':
				this.getExtensionProposal(this.proposalID);
				break;

			case 'AB':
				this.getAllowanceProposal(this.proposalID);
				break;

			case 'AC':
				this.getCommercialCompetenceProposal(this.proposalID);
				break;

			case 'LA':
				this.getExtraProposal(this.proposalID);
				break;
			
			case 'RV':
			this.loadProposal = true;
				break;

			default:
				break;
		}
	}

	getExtensionProposal(proposalID) {
		this.bcAccountClientService.getExtensionProposal(proposalID).subscribe(result => {
			if (result.Success) {
				this.proposal = result.Result;
				this.loadProposal = true;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getAllowanceProposal(silent) {
		this.bcAccountClientService.getAllowanceProposal(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.proposal = result.Result;
				this.loadProposal = true;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getJuridicProposal(proposalID) {
		this.bcAccountClientService.getJuridicProposal(proposalID).subscribe(result => {
			if (result.Success) {
				this.proposal = result.Result;
				this.loadProposal = true;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getCommercialCompetenceProposal(proposalID){
		this.commercialCompetenceService.getProposalData(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.proposal = result.Result;
				this.loadProposal = true;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getExtraProposal(proposalID){
		this.limiteAdicionalProposalService.getLaProposal(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.proposal = result.Result;
				this.loadProposal = true;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/proposal-view-modal.component.ts